import { Suspense, useEffect } from 'react'
import {
  Await,
  Navigate,
  useLoaderData,
  useSearchParams,
} from 'react-router-dom'
import { Plan } from '../../types'
import ErrorPage from '../ErrorPage'
import LoadingPage from '../LoadingPage'

export default function PaymentCompletionPage() {
  const data = useLoaderData() as { completed: Promise<boolean> }

  const [searchParams] = useSearchParams()

  const currency = searchParams.get('currency')!
  const paymentIntentClientSecret = searchParams.get(
    'payment_intent_client_secret',
  )!
  const plan = searchParams.get('plan')! as Plan
  const subscriptionId = searchParams.get('subscription_id') ?? ''

  useEffect(() => {
    const timeout = setTimeout(() => {
      // NOTE: Just wait one second to let the Facebook Pixel do its job
    }, 1000)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <Suspense fallback={<LoadingPage />}>
      <Await errorElement={<ErrorPage />} resolve={data.completed}>
        {(completed) =>
          completed ? (
            <Navigate to="/account/subscription" />
          ) : (
            <Navigate
              to={`/checkout/payment?client_secret=${paymentIntentClientSecret}&currency=${currency}&plan=${plan}${subscriptionId ? `&subscription_id=${subscriptionId}` : ''}`}
            />
          )
        }
      </Await>
    </Suspense>
  )
}
